import { isNotUndefined } from 'infrastructure/functions';

import {
  genThresholdText,
  additionalFollowUpText,
  croOrDncText,
  needEscalateText,
  uniqueDaysTextWithType,
  readingInTargetRangeText,
} from '../helpers';

import type { TMaWeightGreenDataOptional } from '../../types';

export const weight = (data: TMaWeightGreenDataOptional) => {
  let text = '';

  const weightReasonText =
    'Patient is enrolled in weight monitoring services for';
  if (isNotUndefined(data.weightReason) && data.weightReason !== 'other') {
    text += `${weightReasonText} ${data.weightReason}. `;
    if (data.weightReasonComment?.trim())
      text += `${data.weightReasonComment}. `;
  }
  if (data.weightReasonComment?.trim()) {
    text += `${weightReasonText} ${data.weightReasonComment?.trim()}. `;
  }

  const thresholdTextWeight = genThresholdText(
    'weight',
    data.weightAvg,
    data.weightAvg30days,
    data.weightAvg90days,
  );
  if (thresholdTextWeight.trim()) text += `\n${thresholdTextWeight}`;

  const inTargetRangeText = readingInTargetRangeText(
    data.weightWithinRange,
    data.weightWithinRangeComment,
  );
  if (inTargetRangeText.trim()) text += `\n${inTargetRangeText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysTextWithType('weight', data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
